module.exports = __webpack_public_path__ + "static/instagram-407edae87dbd051235b1fd6069b81c2b.jpg";